export const GET_REF_CAMPAIGNS_WITH_PAGINATION = 'GET:REF:CAMPAGNES:WITH:PAGINATION';
export const SEARCH_REF_CAMPAIGNS = 'SEARCH:REF:CAMPAGNES';
export const CLEAR_REF_CAMPAIGNS = 'CLEAR:REF:CAMPAIGNS';
export const GET_REF_CAMPAIGN_DETAILS = 'GET:REF:CAMPAIGN:DETAILS';
